<template>
  <div class="mb-4">
    <span class="caption grey--text text--darken-1">{{label}}</span>
    <v-select
      v-model="selected"
      @change="setValues"
      clearable
      :items="options"
      hide-details
      chips
      @click:clear="() => (setEmpty(''))"
      :multiple="multiple"
      solo
      class="thin-border"
    />
    <v-text-field
      class="pl-2"
      v-if="isOther"
      v-model="otherText"
      @change="() => setValues(otherText)"
    />
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Array],
    },
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() { 
    return {
      selected: null,
      otherText: '',
      hasOther: false
    }
  },
  computed: {
    isOther() {
      return this.selected === this.other.value || this.hasOther
    },
    other() {
      return (
        this.options.find(opt => opt.value.endsWith('other')) || {
          value: 'other',
          text: 'Outro'
        }
      )
    }
  },
  methods: {
    getOptionId(val){
      return (this.options.find(opt => opt.value === val) || this.other).value
    },
    getSelectedId(val) {
      if (!val) return null
      return (this.options.find(opt => opt.value === val) || this.other).value
    },
    setValues(newVal){
      if(this.multiple){
        const newValues = [...this.selected].map((el)=>(el === this.other.value ? this.otherText : el))
        this.$emit('input', newValues)
      } else {
        this.$emit('input', newVal)
      }
    },
    setEmpty(){
      this.$emit('input', this.multiple ? [] : '')
    },
    updateComponentsData(){
      this.hasOther = false
      if(this.multiple){
        this.selected = (this.value || []).map(
          el => {
            const newEl = this.getOptionId(el)
            if(newEl === this.other.value){
              this.otherText = el
              this.hasOther = true
            }
            return newEl
          }
        );
      } else {
        this.selected = this.getSelectedId(this.value)
        if (this.isOther) {
          this.otherText = this.value
        }
      }
    }
  },
  watch: {
    value() {
      this.updateComponentsData()
    }
  },
  created() {
    this.updateComponentsData()
  }
}
</script>